<template>
  <v-expansion-panel v-if="selectedToken !== ''">
    <v-expansion-panel-header>Position</v-expansion-panel-header>
    <v-expansion-panel-content>
      <section class="item-body">
        <v-col>
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                v-model="contentGeometrX"
                outlined
                dense
                label="X (µm)"
                color="primary"
                type="number"
                readonly
                @click="dialog = true"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="contentGeometrY"
                outlined
                dense
                :label="is3d ? 'Y (µm)' : 'Y (µm, center = 0)'"
                color="primary"
                type="number"
                readonly
                @click="dialog = true"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-if="is3d"
                v-model="contentGeometrZ"
                outlined
                dense
                label="Z (µm)"
                color="primary"
                type="number"
                readonly
                @click="dialog = true"
              />
            </v-col>
          </v-row>
          <v-dialog
            v-model="dialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="faded"
                block
                small
                v-bind="attrs"
                v-on="on"
              >
                Manual insert
              </v-btn>
            </template>

            <v-card>
              <v-card-title> Manual size and position insert </v-card-title>

              <v-card-text>
                Insert new values to size and position to this element.
                <p class="text-subtitle-2 mt-5">
                  Position (&mu;m)
                </p>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="contentGeometrX"
                      outlined
                      dense
                      label="X (µm)"
                      color="primary"
                      type="number"
                      @keydown.enter="updateSizeAndPositionLocal"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="contentGeometrY"
                      outlined
                      dense
                      label="Y (µm)"
                      color="primary"
                      type="number"
                      @keydown.enter="updateSizeAndPositionLocal"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-if="is3d"
                      v-model="contentGeometrZ"
                      outlined
                      dense
                      label="Z (µm)"
                      color="primary"
                      type="number"
                      @keydown.enter="updateSizeAndPositionLocal"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="updateSizeAndPositionLocal"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </section>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Position",
  data: () => {
    return {
      dialog: false,
      posX: 0,
      posY: 0,
      posZ: 0
    };
  },
  props: {
    is3d: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // Ao abrir, parte da posição atual: editar só X não pode zerar Y (e vice-versa)
    dialog(open) {
      if (!open || !this.geometryData) return;
      this.posX = Number(this.contentGeometrX);
      this.posY = Number(this.contentGeometrY);
      this.posZ = Number(this.contentGeometrZ);
    }
  },
  methods: {
    ...mapActions("simulator", [
      "setCurrentGeometryPosY",
      "setCurrentGeometryPosX",
      "setCurrentGeometryPosZ",
      "updateSizeAndPosition",
    ]),
    updateSizeAndPositionLocal: function () {
      this.dialog = false;
      

      if (this.is3d) {
        this.setCurrentGeometryPosX(this.posX);
        this.setCurrentGeometryPosY(this.posY);
        this.setCurrentGeometryPosZ(this.posZ);
      } else {
        this.setCurrentGeometryPosX(
          (this.posX + this.coordinates.x / 2) * this.dimensions.relationship.x -
            this.originOffset.x
        );

        // Y do Meep cresce para cima; no canvas cresce para baixo
        this.setCurrentGeometryPosY(
          (this.coordinates.y / 2 - this.posY) * this.dimensions.relationship.y -
            this.originOffset.y
        );
      }
    },
  },
  computed: {
    ...mapGetters("simulator", [
      "selectedToken",
      "geometryData",
      "dimensions",
      "coordinates",
      "currentGeometry",
    ]),
    // Distância (px) entre o x,y do Konva e o centro do objeto: só o bloco (Rect) é
    // posicionado pelo canto; círculo, triângulo, fontes e monitores já têm x,y no centro
    originOffset() {
      const { shape, width, height } = this.geometryData;
      if (this.geometryData.class === "geometry" && shape === "block") {
        return { x: width / 2, y: height / 2 };
      }
      return { x: 0, y: 0 };
    },
    contentGeometrX: {
      get() {
        if(!this.geometryData) return 0;
        let pos;
        if (this.is3d) {
          pos = this.geometryData.x;
        } else {
          pos = (this.geometryData.x + this.originOffset.x) /
            this.dimensions.relationship.x -
          this.coordinates.x / 2;
        }
        return pos.toFixed(3);
      },
      set(value) {
        this.posX = Number(value);
      },
    },
    contentGeometrY: {
      get() {
        if(!this.geometryData) return 0;
        let pos;
        if (this.is3d) {
          pos = this.geometryData.y;
        } else {
          pos = this.coordinates.y / 2 -
            (this.geometryData.y + this.originOffset.y) / this.dimensions.relationship.y;
        }
        return pos.toFixed(3);
      },
      set(value) {
        this.posY = Number(value);
      },
    },
    contentGeometrZ: {
      get() {
        if(!this.geometryData) return 0;
        return Number(this.geometryData.z || 0).toFixed(3);
      },
      set(value) {
        this.posZ = Number(value);
      },
    },
  },
};
</script>